import { render, staticRenderFns } from "./MainCard.vue?vue&type=template&id=1ba52f97&scoped=true&"
import script from "./MainCard.vue?vue&type=script&lang=js&"
export * from "./MainCard.vue?vue&type=script&lang=js&"
import style0 from "./MainCard.vue?vue&type=style&index=0&id=1ba52f97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba52f97",
  null
  
)

export default component.exports